
export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '安心の保険完備',
      description: '万が一の事故にも対応できる保険に加入しています',
    },
    {
      icon: 'ri-team-line',
      title: '経験豊富なスタッフ',
      description: '熟練のドライバーが丁寧に対応いたします',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '明朗会計',
      description: '事前見積もりで追加料金の心配なし',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '迅速な対応',
      description: 'お急ぎの場合も柔軟に対応いたします',
    },
  ];

  return (
    <section className="relative py-12 md:py-20 lg:py-32 bg-gradient-to-br from-[#ede9e3] via-white to-[#ede9e3] overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute top-20 left-10 w-48 md:w-72 h-48 md:h-72 bg-[#ebe960]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-64 md:w-96 h-64 md:h-96 bg-[#ebe960]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16 lg:mb-20">
          <span className="inline-block px-4 md:px-6 py-1.5 md:py-2 bg-[#ebe960]/30 text-gray-900 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6">
            ABOUT US
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-4 md:mb-6">
            私たちについて
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            長崎県で信頼される軽運送サービスを提供しています
          </p>
        </div>

        {/* 特徴カード */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 lg:gap-8 mb-10 md:mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl md:rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-gradient-to-br from-[#ebe960] to-[#c4a000] rounded-xl md:rounded-2xl flex items-center justify-center mb-3 sm:mb-4 md:mb-6 mx-auto">
                <i className={`${feature.icon} text-xl sm:text-2xl md:text-3xl text-gray-900`}></i>
              </div>
              <h3 className="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2 md:mb-3 text-center">
                {feature.title}
              </h3>
              <p className="text-[10px] sm:text-xs md:text-sm text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* 説明文 */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 lg:p-12 shadow-xl border border-gray-100">
            <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-left">
              みなとサービスは、<strong className="text-gray-900 font-bold">長崎県を拠点</strong>とした軽運送事業者です。<br />
              <strong className="text-gray-900 font-bold">引越し</strong>、<strong className="text-gray-900 font-bold">家具・家電の運搬</strong>、
              <strong className="text-gray-900 font-bold">不用品整理</strong>、<strong className="text-gray-900 font-bold">貨物配送</strong>など、幅広いニーズに対応しています。<br />
              地域密着型のサービスで、<br className="hidden sm:block" />
              お客様一人ひとりに寄り添った丁寧な対応を心がけています。<br />
              <strong className="text-gray-900 font-bold">24時間365日対応</strong>可能ですので、<br className="hidden sm:block" />
              お急ぎの場合もお気軽にご相談ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
